import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getInboxLeads = createAsyncThunk(
  "LeadsInbox/getInboxLeads",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/recruitment/textMessages/getInboxLeads?limit=${data.limit}&userId=${data.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

